import {
  MeasureEntity,
} from './measureEntity';
import { ChestCircumference } from './valueObjects/chestCircumference';
import { HeadCircumference } from './valueObjects/headCircumference';
import { Height } from './valueObjects/height';
import { MeasureDate } from './valueObjects/measureDate';
import { MeasurerId } from './valueObjects/measurerId';
import { MeasurerType } from './valueObjects/measurerType';
import { ParentId } from './valueObjects/parentId';
import { Weight } from './valueObjects/weight';

import type {
  MeasurePropsPub,
  MeasurePropsPvt,
} from './measureEntity';
import type { EntityDataPubType } from '@/domain/entityBase';
import type { EntityDataPubNotNullType, EntityPubNotNullType } from '@/domain/entityPub';
import type { MeasureJsonPub, MeasureJsonPvt } from '@/types/domain/measure/entities/measureEntity';

import { FactoryPub } from '@/domain/factoryPub';

/**
 * 測定ファクトリ
 */
export class MeasureFactory extends FactoryPub<
  MeasureEntity,
  MeasurePropsPvt,
  MeasureJsonPvt,
  MeasurePropsPub,
  MeasureJsonPub
> {
  comparePub = (
    a: EntityDataPubType<MeasureJsonPvt, MeasureJsonPub>,
    b: EntityDataPubType<MeasureJsonPvt, MeasureJsonPub>,
  ) => {
    const da = new Date(a.data.measureDate);
    const db = new Date(b.data.measureDate);
    return da < db ? 1 : -1;
  };

  create(
    props: MeasurePropsPvt,
    propsPub: EntityPubNotNullType<MeasurePropsPub>,
  ): MeasureEntity {
    return new MeasureEntity(props, propsPub);
  }

  createFromEntityDataPub(
    props: EntityDataPubNotNullType<MeasureJsonPvt, MeasureJsonPub>,
  ): MeasureEntity {
    return this.create({
      measureDate: MeasureDate.create(new Date(props.data.measureDate)),
      height: props.data.height ? Height.create(props.data.height) : undefined,
      weight: props.data.weight ? Weight.create(props.data.weight) : undefined,
      headCircumference:
        props.data.headCircumference
          ? HeadCircumference.create(props.data.headCircumference)
          : undefined,
      chestCircumference:
        props.data.chestCircumference
          ? ChestCircumference.create(props.data.chestCircumference)
          : undefined,
      measurerId: MeasurerId.create(props.data.measurerId),
      measurerType: MeasurerType.create(props.data.measurerType),
      parentId: ParentId.create(props.data.parentId),
      childId: ParentId.create(props.data.childId),
    }, {
      sendId: props.pub.sendId,
      replyId: props.pub.replyId,
      data: {},
    });
  }
}
